import { DropdownOption } from '@salvapp/ui-components/build/dropdown/dropdown.types';
import { InternalApiAlertType } from '../api-internal';
import { ORGANISATION_FEATURE } from '../organisation/feature/helper';

export const ALERT_TYPES = Object.values(InternalApiAlertType);

const getAlertTypeDropdownOptions = (features: string[]): DropdownOption[] => {
  return ALERT_TYPES.filter((alertType) => {
    switch (alertType) {
      case InternalApiAlertType.SCREENING:
        return features.includes(ORGANISATION_FEATURE.SANCTIONS);
      case InternalApiAlertType.MONITORING:
        return features.includes(ORGANISATION_FEATURE.MONITORING);
      case InternalApiAlertType.BRIDGE:
        return features.includes(ORGANISATION_FEATURE.BRIDGE);
      case InternalApiAlertType.MANUAL:
        return true;
    }
  }).map((type) => ({
    key: type,
    label: type,
    value: type,
  }));
};

export { getAlertTypeDropdownOptions };
